import { render, staticRenderFns } from "./CartMenu.vue?vue&type=template&id=ae3336d8&scoped=true&"
import script from "./CartMenu.vue?vue&type=script&lang=js&"
export * from "./CartMenu.vue?vue&type=script&lang=js&"
import style0 from "./CartMenu.vue?vue&type=style&index=0&id=ae3336d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3336d8",
  null
  
)

export default component.exports